import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  makeStyles,
  withStyles,
  Button,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  const surfaceConfig = theme.palette.surface[theme.palette.type];
  const containedConfig = surfaceConfig.button.contained;
  const outlinedConfig = surfaceConfig.button.outlined;
  const buttonConfig = theme.typography.button;

  return {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      alignItems: 'center',
      justifyContent: 'left',
      minWidth: 353,
    },
    btnContained: {
      marginLeft: 0,
      paddingLeft: buttonConfig.paddingLeft,
      paddingRight: buttonConfig.paddingRight,
      borderRadius: buttonConfig.borderRadius,
      height: buttonConfig.height,
      backgroundColor: containedConfig.bgColor,
      '&:hover': {
        backgroundColor: containedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: containedConfig.border,
        borderColor: containedConfig.borderColor,
        backgroundColor: containedConfig.bgColor,
      },
    },
    btnOutlined: {
      border: outlinedConfig.border,
      color: outlinedConfig.color,
      marginRight: theme.spacing(1),
      backgroundColor: outlinedConfig.bgColor,
      '&:hover': {
        border: outlinedConfig.hoveredBorder,
        backgroundColor: outlinedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: outlinedConfig.selectedBorder,
        backgroundColor: outlinedConfig.selectedBgColor,
      },
    },
  };
});

function AlertDialog(props) {
  const {
    open: visible,
    title,
    description,
    // SubComponents,
    renderActions,
    onClose,
    onAfterClose,
  } = props;

  const classes = useStyles();
  const [open, setOpen] = useState(visible);

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  const handleClose = () => {
    setOpen(!visible);
    onClose();
  };

  const handeExited = () => {
    onAfterClose();
  };

  const renderDefaultActions = () => (
    <div>
      <Button onClick={handleClose} color="primary" variant="contained" className={classes.btnContained}>
        OK
      </Button>
    </div>
  );

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExited={handeExited}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Typography variant="h6">
            {title}
          </Typography>
          <span />
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText variant="subtitle2">
            <Typography variant="subtitle2">{description}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {renderActions() || renderDefaultActions()}
        </DialogActions>
      </Dialog>
    </div>
  );
}

AlertDialog.defaultProps = {
  open: false,
  title: 'Note!',
  description: 'When requiring users to interact with the page, but without jumping to a new page and interrupting the',
  // SubComponents: null,
  onClose: () => { },
  onAfterClose: () => { },
  renderActions: () => { },
};

AlertDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  // SubComponents: PropTypes.func,
  onClose: PropTypes.func,
  onAfterClose: PropTypes.func,
  renderActions: PropTypes.func,
};

export default AlertDialog;
